import { useMemo } from 'react'
import { Web3Provider } from '@ethersproject/providers'
import { useWeb3React } from '@web3-react/core'
import { parseChainId } from '../chains'
import { DEFAULT_CHAIN, SUPPORTED_CHAINS } from 'config'

export function useWeb3() {
  const web3 = useWeb3React<Web3Provider>()
  const { chainId } = web3

  const currentChain = useMemo(
    () =>
      chainId && SUPPORTED_CHAINS.includes(parseChainId(chainId))
        ? parseChainId(chainId)
        : DEFAULT_CHAIN,
    [chainId],
  )

  const isChainUnsupported = useMemo(
    () => Boolean(chainId && !SUPPORTED_CHAINS.includes(parseChainId(chainId))),
    [chainId],
  )

  return {
    ...web3,
    isWalletConnected: web3.active,
    walletAddress: web3.account,
    chainId: parseChainId(currentChain),
    isChainUnsupported,
  }
}
